module.exports = __webpack_public_path__ + "static/media/image1.6c9cc62e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/image1.jpg
// module id = 364
// module chunks = 0